const routes = [{
  path: "/externalMat",
  name: "externalMatLayout",
  component: () => import("@/modules/externalMat/components/RouteLayout.vue"),
  meta: {
    title: "",
    hidden: false,
    icon: "tree",
    isNew: true,
    needLogin: false
  },
  redirect: {
    name: "externalMatLogin"
  },
  children: [{
    path: "login",
    name: "externalMatLogin",
    component: () => import("@/modules/externalMat/pages/login/index.vue"),
    meta: {
      title: "登录",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false
    }
  }, {
    path: "manage",
    name: "externalMatManage",
    component: () => import("@/modules/externalMat/pages/material/manageList.vue"),
    meta: {
      title: "素材管理",
      hidden: false,
      icon: "tree",
      isNew: true
    }
  }, {
    path: "overview",
    name: "externalMatOverview",
    component: () => import("@modules/externalMat/pages/material/dataOverview.vue"),
    meta: {
      title: "数据概览",
      hidden: false,
      icon: "tree",
      isNew: true
    }
  }, {
    path: "article",
    name: "externalMatArticle",
    component: () => import("@modules/externalMat/pages/article/index.vue"),
    meta: {
      title: "素材编辑",
      hidden: false,
      icon: "tree",
      isNew: true
    }
  }]
}];
export default routes;